import * as React from 'react';
import { FONT_COLOR, COLOR_A, COLOR_B, BACKGROUND_COLOR } from './CONSTANTS';
import SourceDisplay from './SourceDisplay';
import TouchSlider from './TouchSlider';
import { RemoveScroll } from 'react-remove-scroll';
import clips from './cds.js';

const archiveUrl = 'http://bbcsfx.acropolis.org.uk/assets/';

const getRandomClip = () => {
	var idx = Math.floor(Math.random() * clips.length);
	var clip = clips[Math.floor(idx)];
	return clip;
};

const SourceView = ({ setUrl, buffer, loadProgress, setClipName }) => {
	const [cd, setCd] = React.useState([]);
	const [cdTitle, setCdTitle] = React.useState('');
	const [currentClip, setCurrentClip] = React.useState('');

	const listItemStyle = {
		fontSize: '0.8rem',
		margin: '2% 0 2% 0',
		color: FONT_COLOR,
	};

	const cdStyle = isActive => ({
		background: isActive ? COLOR_A : '',
		color: isActive ? BACKGROUND_COLOR : FONT_COLOR,
	});
	const loadProgressStyle = (isActive, loadProgress, dir) => ({
		height: '100%',
		width: isActive ? `${loadProgress * 100}%` : '100%',
		background: isActive ? COLOR_A : '',
		float: dir ? dir : 'none',
	});
	const loadProgressWrapperStyle = {
		height: '0.4rem',
		width: '100%',
	};

	return (
		<div style={{ height: '100%', width: '100%' }}>
			<div style={{ fontSize: '0.5rem', textAlign: 'center', color: 'grey' }}>
				All sounds property of the British Brodcasting Corporation, Copyright 2018 © BBC
			</div>
			
				<div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'row' }}>
					<div
						style={{
							height: '100%',
							width: '50%',
							display: 'flex',
							flexDirection: 'column',
							overflowY: 'scroll',
							WebkitOverflowScrolling: 'touch',
						}}
					>
						{Object.keys(clips).map(title => (
							<div
								style={{ ...listItemStyle, ...cdStyle(title == cdTitle) }}
								key={title}
								onClick={() => {
									setCd(clips[title]);
									setCdTitle(title);
								}}
							>
								{title}
							</div>
						))}
					</div>
					<div
						style={{
							height: '100%',
							width: '50%',
							display: 'flex',
							flexDirection: 'column',
							overflowY: 'scroll',
							WebkitOverflowScrolling: 'touch',
						}}
					>
						{cd.map(clip => (
							<div
								style={listItemStyle}
								key={clip.location}
								onClick={() => {
									if (loadProgress == 1) {
										setCurrentClip(clip.location);
										setUrl(archiveUrl + clip.location);
										setClipName(clip.description);
									}
								}}
							>
								<div style={loadProgressWrapperStyle}>
									<div
										style={loadProgressStyle(clip.location == currentClip, loadProgress, 'right')}
									/>
								</div>
								<div>{`${clip.description}, (${clip.secs}s)`}</div>
								<div style={loadProgressWrapperStyle}>
									<div style={loadProgressStyle(clip.location == currentClip, loadProgress)} />
								</div>
							</div>
						))}
					</div>
				</div>
		</div>
	);
};

export default SourceView;
